import React, { useContext } from 'react';

export const InterviewNowAttributesContext = React.createContext<{
  isNonInteractive?: boolean;
  isDisabled?: boolean;
  sessionId?: string;
  isPredemo?: boolean;
}>({
  isDisabled: false,
  isNonInteractive: false,
  isPredemo: false,
  sessionId: undefined,
});

export const useInterviewNowAttributes = () => {
  const ctx = useContext(InterviewNowAttributesContext);
  if (!ctx) {
    throw new Error(
      'useInterviewNowAttributes must be used within InterviewNowAttributesContext.Provider'
    );
  }
  return ctx;
};
